import { useState } from 'react';
import ScrollReveal from '@/components/ScrollReveal';
import { useLanguage } from '@/lib/i18n';
import { Mail, Copy, Check, Instagram, Youtube, Music, Headphones } from 'lucide-react';

const EMAIL = 'contact@zateviss.com';
const EMAILDEMOS = 'demos@zateviss.com';

const socialLinks = [
  { icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/zateviss', bg: "images/instabg.jpeg" },
  { icon: Headphones, label: "Spotify", href: "https://open.spotify.com/intl-tr/artist/5VnhzFb2I1U9qLmLbj6fhZ", bg: "images/spotifybg.jpeg" },
];

export default function Contact() {
  const { t } = useLanguage();

  return (
    <main id="main-content" className="pt-32 pb-24" data-testid="contact-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#00E5FF]/60 mb-4">GET IN TOUCH</p>
          <h1
            className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-4"
            data-testid="contact-page-title"
          >
            {t('contact_title')}
          </h1>
          <p className="text-white/35 text-lg mb-16" data-testid="contact-page-subtitle">
            {t('contact_subtitle')}
          </p>
        </ScrollReveal>

        {/* Email Card */}
        <ScrollReveal delay={0.1}>
          <a className="relative mb-16" data-testid="contact-email-card" href='mailto:contact@zateviss.com'>
            {/* Glow */}
            <div className="absolute -inset-2 bg-gradient-to-r from-[#7F00FF]/12 to-[#00E5FF]/12 rounded-3xl blur-2xl opacity-60" />

            <div className="relative bg-[#0A0A0A] border border-white/[0.08] rounded-2xl p-8 md:p-10 gradient-border mb-8">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-12 rounded-full bg-[#7F00FF]/[0.08] border border-[#7F00FF]/15 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-[#7F00FF]" />
                </div>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/25">
                    {t('contact_email_label')}
                  </p>
                  <p className="text-lg font-medium mt-0.5">{EMAIL}</p>
                  <p className="text-sm text-white/30 mt-1 cursor-pointer flex items-center gap-1" >
                    {t("contact_email_desc")}
                  </p>
                </div>
              </div>
            </div>
          </a>
        </ScrollReveal>

        {/* Email Card */}
        <ScrollReveal delay={0.1}>
          <a className="relative mb-16" data-testid="contact-email-card" href='mailto:demos@zateviss.com'>
            {/* Glow */}
            <div className="absolute -inset-2 bg-gradient-to-r from-[#7F00FF]/12 to-[#00E5FF]/12 rounded-3xl blur-2xl opacity-60" />

            <div className="relative bg-[#0A0A0A] border border-white/[0.08] rounded-2xl p-8 md:p-10 gradient-border mb-8">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-12 rounded-full bg-[#7F00FF]/[0.08] border border-[#7F00FF]/15 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-[#7F00FF]" />
                </div>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/25">
                    {t('contact_email_label')}
                  </p>
                  <p className="text-lg font-medium mt-0.5">{EMAILDEMOS}</p>

                  <p className="text-sm text-white/30 mt-1 cursor-pointer flex items-center gap-1" >
                    {t("contact_email_desc_demos")}
                  </p>
                </div>
              </div>
            </div>
          </a>
        </ScrollReveal>


        {/* Social Links */}
        <ScrollReveal delay={0.2}>
          <div className="mt-16" data-testid="contact-social">
            <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
              {socialLinks.map(social => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`contact-social-${social.label.toLowerCase()}`}
                  className="
                  relative overflow-hidden
    flex items-center justify-center gap-3 p-4 rounded-xl
    border border-white/[0.31]
    hover:border-gray-700/[0.6]
    transition-colors duration-200 group
    bg-cover bg-center bg-no-repeat
  "
                  style={{ backgroundImage: `url(${social.bg})` }}
                >

                  <div className="relative z-10 flex items-center gap-3">

                    <social.icon className="w-6 h-6 text-white/80 group-hover:text-white drop-shadow-lg transition-colors duration-200" />
                    <span className="text-xl text-white/60 font-bold group-hover:text-white drop-shadow-lg transition-colors duration-200 p-4">
                      {social.label}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </main>
  );
}
